import * as React from "react"
import {EnvironmentalLogo} from "./environmentalLogo";
import {FaLeaf} from "react-icons/fa";
import {Col} from "react-bootstrap";
import {useEnvironmentalClaimsQuery} from "../../../../../hooks/useEnvironmentalClaimsQuery";

export const EnvironmentalClaims = () => {
    const {model: {claims}} = useEnvironmentalClaimsQuery();

    // If the environmental claims array is empty, return the EnvironmentalLogo component only
    if (!claims || claims.length === 0) {
        return (
            <Col lg={6}>
                <div className="d-flex flex-column align-items-start">
                    <EnvironmentalLogo/>
                </div>
            </Col>
        )
    }

    // If the environmental claims array is not empty, return the EnvironmentalLogo component and the environmental claims
    return (
        <Col lg={6}>
            <div className="d-flex flex-column align-items-start">
                <EnvironmentalLogo/>
                {claims.map((claim, index) => (
                    <div key={index} className="m-3 d-flex">
                        <FaLeaf size={28} className="bullet-icon text-green me-1" aria-hidden/>
                        <div style={{width: '100%'}}>
                            <div style={{wordWrap: 'break-word'}}>
                                {claim.description}
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        </Col>
    )
}